/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_Summary_High_IntensityInputs */

const en_ui_te_summary_high_intensity = /** @type {(inputs: Ui_Te_Summary_High_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-intensity session with strong anaerobic stimulus.`)
};

const de_ui_te_summary_high_intensity = /** @type {(inputs: Ui_Te_Summary_High_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochintensiv — starker anaerober Reiz.`)
};

/**
* | output |
* | --- |
* | "High-intensity session with strong anaerobic stimulus." |
*
* @param {Ui_Te_Summary_High_IntensityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_summary_high_intensity = /** @type {((inputs?: Ui_Te_Summary_High_IntensityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_Summary_High_IntensityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_summary_high_intensity(inputs)
	return de_ui_te_summary_high_intensity(inputs)
});